import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ColetaMensal } from '@core/models/indicator.model';
import { environment } from '../../../../environments/environment';

export interface TimeSeriesPoint {
  label: string;
  value: number;
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/api/analytics`;

  private readonly loadingState = signal(false);
  readonly loading = this.loadingState.asReadonly();

  async getIndicatorTrend(indicadorId: string): Promise<TimeSeriesPoint[]> {
    this.loadingState.set(true);
    try {
      return await lastValueFrom(this.http.get<TimeSeriesPoint[]>(`${this.apiUrl}/trend/${indicadorId}`));
    } finally {
      this.loadingState.set(false);
    }
  }

  async getSystemSummary() {
    this.loadingState.set(true);
    try {
      return await lastValueFrom(this.http.get<{activeIndicators: number, globalPendingTasks: number}>(`${this.apiUrl}/summary`));
    } finally {
      this.loadingState.set(false);
    }
  }

  async getAllResponses(): Promise<ColetaMensal[]> {
    this.loadingState.set(true);
    try {
      return await lastValueFrom(this.http.get<ColetaMensal[]>(`${this.apiUrl}/responses`));
    } finally {
      this.loadingState.set(false);
    }
  }
}
